import { InconnectClient } from '@inconnect/core';
import { BASE_URL, CLIENT_ID } from './config'; // ✅ adjust path if needed

function authLog(event: string, detail?: string): void {
  const msg = detail ? `${event} — ${detail}` : event;
  console.warn(`[CareAmy Auth] ${new Date().toISOString()} | ${msg}`);
}

let unauthTimer: ReturnType<typeof setTimeout> | null = null;

export function cancelUnauthRedirect(): void {
  if (unauthTimer) {
    clearTimeout(unauthTimer);
    unauthTimer = null;
    authLog('CANCEL_UNAUTH_REDIRECT', 'token refresh succeeded, redirect cancelled');
  }
}

export const inconnect = new InconnectClient({
  baseUrl: BASE_URL,
  clientId: CLIENT_ID,
  onUnauthenticated: () => {
    if (unauthTimer) {
      authLog('UNAUTH_DEBOUNCE_SKIP', 'redirect already scheduled, ignoring duplicate');
      return;
    }
    authLog('UNAUTH_FIRED', 'session unauthenticated — starting 1s debounce before redirect');
    unauthTimer = setTimeout(() => {
      unauthTimer = null;
      authLog('UNAUTH_REDIRECT', 'debounce elapsed, clearing session and redirecting to /');
      localStorage.removeItem('ClinicalSettings');
      localStorage.removeItem('AdministrativeSettings');
      window.location.href = '/';
    }, 1000);
  },
});